<template>
  <div>
    <div class="row">
      <div class="col-md-8 col-md-offset-2">
        <div class="card card-wizard" id="wizardCard">
          <form-wizard ref="wizard"
                       color='#31bebf'
                       @on-change="scrollToTop"
                       error-color="#31bebf"
                       :title="title"
                       :subtitle="chineseFields && spanishFields ? translatedFields['patient_results_retrieval'] : ''">

            <tab-content :title="translatedFields['site']"
                         :before-change="validateFirstStep"
                         route="/patient/check-results/site"
                         icon="ti-settings">
              <first-step ref="firstStep"
                          v-on:jumpToTheNextPage="jumpToTheNextPage"
              ></first-step>
            </tab-content>
  
            <tab-content :title="translatedFields['medical_data']"
                         icon="ti-user"
                         :before-change="validateSecondStep"
                         route="/patient/check-results/medical-data"
                         >
              <second-step ref="secondStep"
                           v-on:nextTab="nextTab">
              </second-step>
            </tab-content>

            <tab-content v-if="$store.state.results.site.allow_results"
                         :title="translatedFields['disclaimer']"
                         :before-change="validateThirdStep"
                         route="/patient/check-results/disclaimer"
                         icon="ti-settings">
              <third-step ref="thirdStep"
                          v-on:result="getResult"
                          v-on:nextTab="nextTab">
              </third-step>
            </tab-content>

            <tab-content v-if="$store.state.results.site.allow_results && 
                               security_code_by_text === true && 
                               security_code_by_email === true && skip_security_code === false"
                         :title="translatedFields['send_method']"
                         :before-change="validateForthStep"
                         route="/patient/check-results/send-method"
                         icon="ti-settings">
              <forth-step ref="forthStep"
                          v-on:nextTab="nextTab">
              </forth-step>
            </tab-content>

            <tab-content v-if="$store.state.results.site.allow_results &&
                         skip_security_code === false"
                         :title="translatedFields['validation']"
                         :before-change="validateFifthStep"
                         route="/patient/check-results/validation"
                         icon="ti-settings">
              <fifth-step ref="fifthStep"
                          v-on:result="getResult"
                          v-on:nextTab="nextTab"
              ></fifth-step>
            </tab-content>

            <tab-content v-if="$store.state.results.site.allow_results"
                         :title="translatedFields['results']"
                         route="/patient/check-results/results"
                         icon="ti-check">
              <sixth-step ref="sixthStep"
                          :result="result"
                          v-on:nextTab="nextTab"
              ></sixth-step>
            </tab-content>

            <button slot="prev" class="btn btn-default btn-fill btn-wd btn-back"><span>{{ translatedFields['back'] }} </span></button>
            <button slot="next" class="btn btn-fill btn-wd btn-next"><span> {{ translatedFields['next'] }}</span></button>
            <button slot="finish" class="btn btn-info btn-fill btn-wd display-none">I agree and Submit</button>
           </form-wizard>

          <div class="row">
            <div class="col-md-12">
              <p v-if="allow_registration" class="m-50">{{ translatedFields['register'] }}
                <router-link to="/patient/register" class="htrx-primary">{{ translatedFields['here'] }}</router-link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import FirstStep from './Wizard/SiteSelectionStep.vue'
  import SecondStep from './Wizard/Data.vue'
  import ThirdStep from './Wizard/DisclaimerStep.vue'
  import ForthStep from './Wizard/ChooseMethod.vue'
  import FifthStep from './Wizard/CheckConfirmationNumber.vue'
  import SixthStep from './Wizard/Result.vue'

  export default {
    data () {
      return {
        translatedFields: '',
        fields_en: {
          next: 'Next',
          back: 'Back',
          patient_results_retrieval: 'Patient Results Retrieval',
          site: 'Site',
          medical_data: 'Medical Data',
          disclaimer: 'Disclaimer',
          send_method: 'Send Method',
          validation: 'Validation',
          results: 'Results',
          register: 'Register',
          here: 'here'
        },
        allow_registration: String(process.env.ALLOW_REGISTRATION) === 'true',
        security_code_by_text: process.env.SECURITY_CODE_BY_TEXT,
        security_code_by_email: process.env.SECURITY_CODE_BY_EMAIL,
        title: process.env.LAB_NAME,
        skip_security_code: process.env.SKIP_SECURITY_CODE,
        result: ''
      }
    },
    components: {
      FirstStep,
      SecondStep,
      ThirdStep,
      ForthStep,
      FifthStep,
      SixthStep
    },
    mounted: function () {
      this.$sidebar.isMinimized = true
    },
    methods: {
      nextTab () {
        this.$refs.wizard.nextTab()
      },
      jumpToTheNextPage () {
        // this method will jump to the next page without any validation
        // do not use it
        this.$refs.wizard.changeTab(0, 1)
      },
      validateFirstStep () {
        return this.$refs.firstStep.validate()
      },
      validateSecondStep () {
        return this.$refs.secondStep.validate()
      },
      validateThirdStep () {
        return this.$refs.thirdStep.validate()
      },
      validateForthStep () {
        return this.$refs.forthStep.validate()
      },
      validateFifthStep () {
        return this.$refs.fifthStep.validate()
      },
      scrollToTop () {
        let elmnt = document.getElementsByClassName('main-panel')[0]
        elmnt.scrollTo(0, 0)
      },
      getResult (data) {
        this.result = data
      },
      checkLanguage () {
        if (this.$store.state.lang.value === 'ES') {
          this.translatedFields = this.$store.state.translation_es
        } else {
          if (this.$store.state.lang.value === 'ZH') {
            this.translatedFields = this.$store.state.translation_zh
          } else {
            this.translatedFields = this.fields_en
          }
        }
      }
    },
    computed: {
      language () {
        this.checkLanguage()
        return this.$store.state.lang.value
      },
      spanishFields () {
        return this.$store.state.translation_es
      },
      chineseFields () {
        return this.$store.state.translation_zh
      }
    },
    watch: {
      language () {
        this.checkLanguage()
      }
    }
  }
</script>

<style scoped>
  .htrx-primary{
    color:#31bebf;
  }

  >>> .vue-form-wizard .wizard-icon-circle {
    background-color: white;
    color: #323737;
    border: 3px solid #323737;
  }

  >>> .vue-form-wizard .wizard-nav-pills>li>a {
    color: #323737;
  }

  >>> div[aria-selected="true"]{
    background-color: #31bebf !important;
  }

  .btn-next {
    background-color: white !important;
    color: #323737 !important;
    min-height: 40px;
    border: 2px solid #31bebf !important;
    border-radius: 20px;
  }

  span button {
    transition: 0.5s;
  }

  .btn-next:hover{
    border: none;
    background-color: #31bebf !important;
    color: white !important;
    padding-left: 25px;
  }

  .btn-next:focus{
    border: none;
    background-color: #31bebf !important;
    color: white !important;
    padding-left: 25px;
  }

  .btn-next span:after {
    content: '\00bb';
    opacity: 1;
    font-size: 17px;
    margin-left: 5px;
  }

  .btn-back{
    background-color: transparent !important;
    color: #f4c617 !important;
    min-height: 40px;
    border: none;
    border-radius: 20px;
  }

  .btn-back span:before {
    content: '\00AB';
    opacity: 1;
    font-size: 17px;
    margin-right: 5px;
  }

  .btn-back:hover{
    border: none !important;
    background-color: #f4c617 !important;
    color: white !important;
    padding-right: 25px;
  }

  .btn-back:focus{
    border: none !important;
    background-color: #f4c617 !important;
    color: white !important;
    padding-right: 25px;
  }

  .display-none {
    display: none;
  }

  .m-50{
    margin-top: 20px;
    padding-bottom: 20px;
    margin-left: 20px;
  }

  @media (max-width: 400px) {
    >>> .vue-form-wizard .wizard-card-footer {
      display: -webkit-box;
      display: -moz-box;
      display: box;

      -webkit-box-orient: vertical;
      -moz-box-orient: vertical;
      box-orient: vertical;
    }

    >>> .vue-form-wizard .wizard-card-footer .wizard-footer-right {
      position: relative;
      min-height: 1px;
      width: 100%;
      margin-top: 10px;

      -webkit-box-ordinal-group: 1;
      -moz-box-ordinal-group: 1;
      box-ordinal-group: 1;
    }

    >>> .vue-form-wizard .wizard-card-footer .wizard-footer-left {
      position: relative;
      min-height: 1px;
      width: 100%;

      -webkit-box-ordinal-group: 2;
      -moz-box-ordinal-group: 2;
      box-ordinal-group: 2;
    }

    .btn-back{
      width: 100%;
    }

    .btn-next{
      width: 100%;
    }

    .btn-submit{
      width: 100%;
    }

    >>> span[role=button] {
      width: 100% !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Results/ResultsWizard.vue